"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sharedStyles = (theme) => ({
    row: {
        position: 'relative',
        display: 'flex',
        padding: theme.spacing(1),
    },
    cell: Object.assign(Object.assign({}, theme.typography.body), { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', '&:not(:last-child)': {
            marginRight: theme.spacing(1),
        }, '&:empty::before': {
            content: '"\\2014"',
            color: theme.palette.textSecondary,
        } }),
});
exports.default = sharedStyles;
